/* Brojanica theme — gallery, accordion, cord, sticky ATC, price from metafields */
(function () {
  'use strict';

  function formatEUR(n, precise) {
    var opts = {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: precise ? 2 : 0,
      maximumFractionDigits: precise ? 2 : 0
    };
    var v = precise ? n : Math.round(n);
    return new Intl.NumberFormat('en-IE', opts).format(v);
  }

  function formatMass(g) {
    var n = Number(g);
    if (!isFinite(n)) return String(g);
    return (Math.round(n * 10) / 10).toFixed(1);
  }

  function computePrice(spot, grams, fineFraction, divisor) {
    var fineAu = grams * fineFraction;
    var goldAtSpot = fineAu * spot;
    var total = goldAtSpot / divisor;
    var costShare = total - goldAtSpot;
    return { spot: spot, fineAu: fineAu, goldAtSpot: goldAtSpot, costShare: costShare, total: total };
  }

  /* Stack shares of GROSS ticket — do not surface ÷divisor to customers */
  function karatTier(karat) {
    var k = String(karat || '').toLowerCase();
    if (k.indexOf('24') !== -1) return '24k';
    if (k.indexOf('18') !== -1) return '18k';
    return '14k';
  }

  function costShares(tier) {
    if (tier === '24k') return { gold: 62, make: 22, vat: 16 };
    if (tier === '18k') return { gold: 58, make: 26, vat: 16 };
    return { gold: 50, make: 34, vat: 16 };
  }

  function applyCostBar(card, tier) {
    var shares = costShares(tier);
    var bar = card.querySelector('[data-cost-bar]');
    if (!bar) return;
    var setSeg = function (key, pct) {
      var seg = bar.querySelector('[data-cost-seg="' + key + '"]');
      if (seg) {
        seg.style.flexGrow = String(pct);
        seg.style.flexBasis = '0';
      }
      var pctEl = bar.querySelector('[data-cost-pct="' + key + '"]');
      if (pctEl) pctEl.textContent = pct + '%';
    };
    setSeg('gold', shares.gold);
    setSeg('make', shares.make);
    setSeg('vat', shares.vat);
    bar.setAttribute(
      'aria-label',
      'Price breakdown: Gold ' + shares.gold + '%, Making & shipping ' +
        shares.make + '%, VAT ' + shares.vat + '%'
    );
    var makeSeg = bar.querySelector('[data-cost-seg="make"]');
    var vatSeg = bar.querySelector('[data-cost-seg="vat"]');
    if (makeSeg) makeSeg.title = 'Making & shipping ' + shares.make + '%';
    if (vatSeg) vatSeg.title = 'VAT ' + shares.vat + '%';
    var goldSeg = bar.querySelector('[data-cost-seg="gold"]');
    if (goldSeg) goldSeg.title = 'Gold ' + shares.gold + '%';
  }

  function initPriceCards() {
    document.querySelectorAll('[data-price-card]').forEach(function (card) {
      var spot = parseFloat(card.dataset.spot) || 120.84;
      var grams = parseFloat(card.dataset.grams) || 2.12; /* 14k default */
      var fine = parseFloat(card.dataset.fine) || 0.585;
      var div = parseFloat(card.dataset.divisor) || 0.50;
      var p = computePrice(spot, grams, fine, div);

      var totalEl = card.querySelector('[data-price-total]');
      var totalPrecise = card.querySelector('[data-price-total-precise]');
      var fineInline = card.querySelector('[data-price-fine-inline]');

      if (totalEl) totalEl.textContent = formatEUR(p.total, false);
      if (totalPrecise) totalPrecise.textContent = formatEUR(p.total, false);
      if (fineInline) fineInline.textContent = 'fine gold ' + p.fineAu.toFixed(1) + ' g';
      var massInline = card.querySelector('[data-price-mass-inline]');
      if (massInline) massInline.textContent = 'Total weight ' + formatMass(grams) + ' g';

      applyCostBar(card, '14k');

      document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
        el.textContent = formatEUR(p.total, false);
      });
      document.querySelectorAll('[data-hero-price]').forEach(function (el) {
        el.textContent = formatEUR(p.total, false);
      });
    });
  }

  function initAccordion() {
    document.querySelectorAll('[data-accordion]').forEach(function (root) {
      root.querySelectorAll('.accordion__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var panelId = btn.getAttribute('aria-controls');
          var panel = panelId ? document.getElementById(panelId) : null;

          root.querySelectorAll('.accordion__btn').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
            var pid = b.getAttribute('aria-controls');
            var p = pid ? document.getElementById(pid) : null;
            if (p) p.classList.remove('is-open');
          });

          if (!expanded && panel) {
            btn.setAttribute('aria-expanded', 'true');
            panel.classList.add('is-open');
          }
        });
      });
    });
  }


  function ensureViewer(gallery) {
    var mount = gallery.querySelector('[data-product-viewer]');
    if (!mount) return null;
    var api = window.BrojanicaProductViewer;
    if (!api) return null;
    var viewer = mount._brojanicaViewer || api.bootFromMount(mount);
    if (viewer && viewer.show) viewer.show();
    return viewer;
  }

  function setViewerCord(value) {
    var mount = document.querySelector('[data-product-viewer]');
    if (!mount) return;
    mount.dataset.cordColor = String(value || 'red').toLowerCase();
    var api = window.BrojanicaProductViewer;
    var viewer = mount._brojanicaViewer || (api && api.bootFromMount(mount));
    if (viewer && viewer.loadCord) viewer.loadCord(value);
  }

  function initGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var frameImg = gallery.querySelector('[data-gallery-main]');
    var frameVideo = gallery.querySelector('[data-gallery-main-video]');
    var deferred = gallery.querySelector('[data-deferred-3d]');
    var hint = gallery.querySelector('[data-mode-hint]');
    var note = gallery.querySelector('[data-gallery-note]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var tabs = gallery.querySelectorAll('[data-mode-tab]');
    ensureViewer(gallery);

    function stopMainVideo() {
      if (!frameVideo) return;
      try { frameVideo.pause(); } catch (e) {}
      frameVideo.removeAttribute('src');
      while (frameVideo.firstChild) frameVideo.removeChild(frameVideo.firstChild);
      frameVideo.load();
      frameVideo.hidden = true;
    }

    function showMainVideo(src, poster, alt) {
      if (!frameVideo || !src) return false;
      if (frameImg) frameImg.hidden = true;
      stopMainVideo();
      frameVideo.muted = true;
      frameVideo.playsInline = true;
      frameVideo.loop = true;
      frameVideo.setAttribute('playsinline', '');
      frameVideo.setAttribute('muted', '');
      if (poster) frameVideo.poster = poster;
      if (alt) frameVideo.setAttribute('aria-label', alt);
      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      frameVideo.appendChild(source);
      frameVideo.hidden = false;
      var play = frameVideo.play();
      if (play && play.catch) play.catch(function () {});
      return true;
    }

    function setMode(mode, src, alt, mediaType, videoSrc, poster) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.modeTab === mode);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mode === mode && (mode === '3d' || t.classList.contains('is-current')));
      });

      if (mode === '3d') {
        stopMainVideo();
        if (frameImg) frameImg.hidden = true;
        if (deferred) deferred.hidden = false;
        if (hint) hint.textContent = 'Inspect the piece';
        if (note) note.textContent = 'Drag to orbit · scroll to zoom — solid gold cross (14k / 18k).';
        gallery.querySelector('.product__frame') && gallery.querySelector('.product__frame').classList.add('product-frame--live');
        ensureViewer(gallery);
      } else {
        if (deferred) deferred.hidden = true;
        var fr = gallery.querySelector('.product__frame');
        if (fr) fr.classList.remove('product-frame--live');
        if (mediaType === 'video' && videoSrc) {
          showMainVideo(videoSrc, poster || src, alt);
          if (hint) hint.textContent = 'Lifestyle';
          if (note) note.textContent = 'Muted loop — solid gold cross (14k / 18k).';
        } else {
          stopMainVideo();
          if (frameImg) {
            frameImg.hidden = false;
            if (src) {
              frameImg.classList.remove('gallery-fade');
              void frameImg.offsetWidth;
              frameImg.src = src;
              if (alt) frameImg.alt = alt;
              frameImg.classList.add('gallery-fade');
            }
          }
          if (hint) hint.textContent = 'Studio stills';
          if (note) note.textContent = 'Studio stills — solid gold cross (14k / 18k).';
        }
      }
    }

    function activateThumb(thumb) {
      var mode = thumb.dataset.mode;
      thumbs.forEach(function (t) {
        t.classList.remove('is-active', 'is-current');
      });
      thumb.classList.add('is-active', 'is-current');
      if (mode === '3d') {
        setMode('3d');
      } else {
        setMode(
          'photo',
          thumb.dataset.src,
          thumb.dataset.alt,
          thumb.dataset.mediaType || 'image',
          thumb.dataset.videoSrc,
          thumb.dataset.poster
        );
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var mode = tab.dataset.modeTab;
        if (mode === '3d') {
          setMode('3d');
          thumbs.forEach(function (t) { t.classList.remove('is-current'); });
          var t3 = gallery.querySelector('[data-mode="3d"]');
          if (t3) t3.classList.add('is-active');
        } else {
          var current = gallery.querySelector('[data-gallery-thumb][data-mode="photo"].is-current') ||
            gallery.querySelector('[data-gallery-thumb][data-mode="photo"]');
          if (current) activateThumb(current);
        }
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateThumb(thumb);
      });
    });

    /* Image lightbox — photos only (skip 3D / video main) */
    var lightbox = gallery.querySelector('[data-gallery-lightbox]');
    var lightboxImg = lightbox && lightbox.querySelector('[data-lightbox-img]');
    var lightboxPrev = lightbox && lightbox.querySelector('[data-lightbox-prev]');
    var lightboxNext = lightbox && lightbox.querySelector('[data-lightbox-next]');
    var lightboxFocusBefore = null;
    var lightboxKeyHandler = null;

    function visibleImageThumbs() {
      var list = [];
      thumbs.forEach(function (t) {
        if (t.dataset.mode !== 'photo') return;
        if (t.dataset.mediaType && t.dataset.mediaType !== 'image') return;
        if (t.hidden || t.style.display === 'none') return;
        if (!t.dataset.src && !t.dataset.full) return;
        list.push(t);
      });
      return list;
    }

    function currentLightboxIndex(list) {
      var active = gallery.querySelector('[data-gallery-thumb][data-mode="photo"][data-media-type="image"].is-current') ||
        gallery.querySelector('[data-gallery-thumb][data-mode="photo"][data-media-type="image"].is-active');
      if (!active) return 0;
      var idx = list.indexOf(active);
      return idx >= 0 ? idx : 0;
    }

    function syncLightboxImage(thumb) {
      if (!lightboxImg || !thumb) return;
      var src = thumb.dataset.full || thumb.dataset.src || '';
      var alt = thumb.dataset.alt || '';
      lightboxImg.src = src;
      lightboxImg.alt = alt;
    }

    function openLightbox() {
      if (!lightbox || !lightboxImg || !frameImg) return;
      if (frameImg.hidden) return; /* 3D or video showing */
      var list = visibleImageThumbs();
      if (!list.length) return;
      var idx = currentLightboxIndex(list);
      var thumb = list[idx];
      syncLightboxImage(thumb);
      lightboxFocusBefore = document.activeElement;
      /* Escape sticky gallery stacking so buy-column UI cannot paint above */
      if (lightbox.parentElement !== document.body) {
        document.body.appendChild(lightbox);
      }
      gallery.classList.add('is-lightbox-open');
      document.documentElement.classList.add('is-lightbox-open');
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
      lightboxKeyHandler = function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          stepLightbox(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          stepLightbox(1);
        }
      };
      document.addEventListener('keydown', lightboxKeyHandler);
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      gallery.classList.remove('is-lightbox-open');
      document.documentElement.classList.remove('is-lightbox-open');
      document.body.style.overflow = '';
      if (lightboxKeyHandler) {
        document.removeEventListener('keydown', lightboxKeyHandler);
        lightboxKeyHandler = null;
      }
      if (lightboxFocusBefore && lightboxFocusBefore.focus) {
        try { lightboxFocusBefore.focus(); } catch (err) {}
      }
      lightboxFocusBefore = null;
    }

    function stepLightbox(delta) {
      var list = visibleImageThumbs();
      if (!list.length) return;
      var idx = currentLightboxIndex(list);
      var next = (idx + delta + list.length) % list.length;
      var thumb = list[next];
      activateThumb(thumb);
      syncLightboxImage(thumb);
    }

    if (frameImg && frameImg.tagName === 'IMG') {
      frameImg.addEventListener('click', function () {
        openLightbox();
      });
      frameImg.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox();
        }
      });
    }

    if (lightbox) {
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeLightbox();
        });
      });
      if (lightboxPrev) {
        lightboxPrev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          stepLightbox(-1);
        });
      }
      if (lightboxNext) {
        lightboxNext.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          stepLightbox(1);
        });
      }
      if (lightboxImg) {
        lightboxImg.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }
    }
  }



  /** Filter photo thumbs by selected cord colour; keep shared Gold/cross closeups. */
  function filterGalleryByCord(value) {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var cord = String(value || 'black').toLowerCase();
    var colors = ['black', 'blue', 'red'];
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb][data-mode="photo"]');
    var firstMatch = null;

    function altCord(alt) {
      var a = String(alt || '').toLowerCase();
      // Prefer explicit leading colour ("Black · …") then "with black cord" style heroes
      for (var i = 0; i < colors.length; i++) {
        var c = colors[i];
        if (new RegExp('^' + c + '\\b').test(a)) return c;
      }
      for (var j = 0; j < colors.length; j++) {
        var c2 = colors[j];
        if (a.indexOf('with ' + c2 + ' cord') !== -1) return c2;
        if (a.indexOf(c2 + ' cord') !== -1) return c2;
        if (a.indexOf('lifestyle') !== -1 && a.indexOf(c2) !== -1) return c2;
      }
      return null;
    }

    thumbs.forEach(function (thumb) {
      var alt = thumb.dataset.alt || '';
      var tagged = altCord(alt);
      var isShared = tagged === null; // Gold cross closeups + untagged shared media
      var isMatch = tagged === cord;
      var show = isShared || isMatch;
      thumb.hidden = !show;
      thumb.style.display = show ? '' : 'none';
      if (isMatch && !firstMatch) firstMatch = thumb;
    });

    var frameImg = gallery.querySelector('[data-gallery-main]');
    var photoTab = gallery.querySelector('[data-mode-tab="photo"]');
    var inPhoto = photoTab && photoTab.classList.contains('is-active');
    if (inPhoto && firstMatch && frameImg) {
      thumbs.forEach(function (t) { t.classList.remove('is-current', 'is-active'); });
      firstMatch.classList.add('is-current', 'is-active');
      frameImg.src = firstMatch.dataset.src;
      if (firstMatch.dataset.alt) frameImg.alt = firstMatch.dataset.alt;
    }
  }


  function currentSelections(form) {
    var cordBtn = form.querySelector('[data-cord-swatch].is-selected');
    var karatBtn = form.querySelector('[data-karat-swatch].is-selected');
    return {
      cord: cordBtn ? cordBtn.dataset.cordValue : 'Black',
      karat: karatBtn ? karatBtn.dataset.karatValue : '14k',
    };
  }

  function findVariant(variants, cord, karat) {
    return variants.find(function (v) {
      var opts = (v.options || []).map(function (o) { return String(o).toLowerCase(); });
      return opts.indexOf(String(cord).toLowerCase()) !== -1 &&
        opts.indexOf(String(karat).toLowerCase()) !== -1;
    });
  }

  function closestPriceCard(fromEl) {
    if (fromEl) {
      var scope = fromEl.closest('[data-price-scope]');
      if (scope) {
        var scoped = scope.querySelector('[data-price-card]');
        if (scoped) return scoped;
      }
    }
    return document.querySelector('[data-price-card]');
  }

  function applyKaratToPriceCard(karat, card) {
    card = card || document.querySelector('[data-price-card]');
    if (!card) return;
    var tier = karatTier(karat);
    var grams;
    var fine;
    var divisor;
    if (tier === '24k') {
      /* 24k LOCKED 2026-09-26: mass 3.0912 · purity 0.999 · ÷0.62 */
      grams = parseFloat(card.dataset.grams24k) || 3.0912;
      fine = parseFloat(card.dataset.fine24k) || 0.999;
      divisor = parseFloat(card.dataset.divisor24k) || 0.62;
    } else if (tier === '18k') {
      grams = parseFloat(card.dataset.grams18k) || 2.4928;
      fine = parseFloat(card.dataset.fine18k) || 0.75;
      divisor = parseFloat(card.dataset.divisor18k) || 0.58;
    } else {
      grams = parseFloat(card.dataset.grams) || 2.12;
      fine = parseFloat(card.dataset.fine) || 0.585;
      divisor = parseFloat(card.dataset.divisor) || 0.50;
    }
    var spot = parseFloat(card.dataset.spot) || 120.84;
    var p = computePrice(spot, grams, fine, divisor);
    card.dataset.karat = tier;
    var el = function (sel) { return card.querySelector(sel); };
    if (el('[data-price-total]')) el('[data-price-total]').textContent = formatEUR(p.total, false);
    if (el('[data-price-total-precise]')) el('[data-price-total-precise]').textContent = formatEUR(p.total, false);
    if (el('[data-price-fine-inline]')) el('[data-price-fine-inline]').textContent = 'fine gold ' + p.fineAu.toFixed(1) + ' g';
    if (el('[data-price-mass-inline]')) el('[data-price-mass-inline]').textContent = 'Total weight ' + formatMass(grams) + ' g';
    if (el('[data-price-metal]')) el('[data-price-metal]').textContent = 'Solid ' + tier;
    applyCostBar(card, tier);
    var honestyKey = tier === '24k' ? 'honesty24k' : tier === '18k' ? 'honesty18k' : 'honesty14k';
    var honesty = card.dataset[honestyKey];
    if (honesty && el('[data-honesty-copy]')) el('[data-honesty-copy]').textContent = honesty;
    var why2 = document.querySelector('[data-why2-copy]');
    if (why2) {
      var w = why2.getAttribute('data-why2-' + tier);
      if (w) why2.textContent = w;
    }
    document.querySelectorAll('[data-sticky-price]').forEach(function (node) {
      node.textContent = formatEUR(p.total, false);
    });
    document.querySelectorAll('[data-hero-price]').forEach(function (node) {
      node.textContent = formatEUR(p.total, false);
    });
  }

  function syncVariantFromPickers(form) {
    var variantsScript = document.getElementById('ProductVariantsJson');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    var sel = currentSelections(form);
    var match = findVariant(variants, sel.cord, sel.karat);
    if (match) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
      var select = form.querySelector('select[name="id"]');
      if (select) select.value = String(match.id);
      var skuLabel = match.sku ? ('SKU · ' + match.sku) : null;
      if (skuLabel) {
        document.querySelectorAll('[data-product-sku]').forEach(function (el) {
          el.textContent = skuLabel;
        });
        document.querySelectorAll('[data-product-sku-inline]').forEach(function (el) {
          el.textContent = match.sku;
        });
        // Fallback for themes without data attrs
        var skuEl = document.querySelector('.product__buy .label-caps');
        if (skuEl && !skuEl.hasAttribute('data-product-sku')) skuEl.textContent = skuLabel;
      }
    }
    setViewerCord(sel.cord);
    filterGalleryByCord(sel.cord);
    applyKaratToPriceCard(sel.karat);
  }

  function initCordPicker() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var picker = form.querySelector('[data-cord-picker]');
    if (picker) {
      picker.querySelectorAll('[data-cord-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          picker.querySelectorAll('[data-cord-swatch]').forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
            b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
          });
          syncVariantFromPickers(form);
        });
      });
    }
  }

  function initKaratPickers() {
    document.querySelectorAll('[data-karat-picker]').forEach(function (picker) {
      picker.querySelectorAll('[data-karat-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          picker.querySelectorAll('[data-karat-swatch]').forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
            b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
          });
          var form = picker.closest('[data-product-form]');
          if (form) {
          syncVariantFromPickers(form);
          } else {
            applyKaratToPriceCard(btn.dataset.karatValue, closestPriceCard(picker));
          }
        });
      });
    });
  }

  function initStickyATC() {
    document.querySelectorAll('[data-scroll-waitlist]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = document.getElementById('waitlist');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var email = target.querySelector('input[type="email"], input[name="contact[email]"]');
        window.setTimeout(function () { if (email) email.focus(); }, 350);
      });
    });

    /* Sticky add-to-cart → same product form (AJAX stay on PDP) */
    document.querySelectorAll('[data-sticky-atc-submit]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = document.querySelector('[data-product-form]');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });
  }

  /* Resolve Downpay €50 deposit selling_plan id (never pay-in-full). */
  function resolveDepositSellingPlanId(form) {
    var fromForm = form && form.getAttribute('data-deposit-selling-plan');
    if (fromForm) return fromForm;
    var hidden = form && form.querySelector('[data-selling-plan], input[name="selling_plan"]');
    if (hidden && hidden.value) return hidden.value;
    try {
      var variants = JSON.parse(document.getElementById('ProductVariantsJson').textContent);
      var v = variants && variants[0];
      var alloc = v && v.selling_plan_allocations && v.selling_plan_allocations[0];
      if (alloc && alloc.selling_plan_id) return String(alloc.selling_plan_id);
    } catch (err) {}
    if (window.downpay && window.downpay.selected_selling_plan_id) {
      return String(window.downpay.selected_selling_plan_id);
    }
    return null;
  }

  /* Re-assert deposit selling_plan input (Downpay pay-in-full removes all selling_plan inputs). */
  function ensureDepositSellingPlanInput(form) {
    var planId = resolveDepositSellingPlanId(form);
    if (!planId || !form) return null;
    form.setAttribute('data-deposit-selling-plan', planId);
    var existing = form.querySelectorAll('input[name="selling_plan"]');
    var kept = null;
    existing.forEach(function (el) {
      if (String(el.value) === String(planId) && !kept) {
        kept = el;
        el.setAttribute('data-selling-plan', '');
      } else {
        el.remove();
      }
    });
    if (!kept) {
      kept = document.createElement('input');
      kept.type = 'hidden';
      kept.name = 'selling_plan';
      kept.value = planId;
      kept.setAttribute('data-selling-plan', '');
      form.appendChild(kept);
    } else {
      kept.value = planId;
    }
    return planId;
  }

  function shopifyRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function cartJsUrl() {
    return shopifyRoot() + 'cart.js';
  }

  function cartAddJsUrl() {
    return shopifyRoot() + 'cart/add.js';
  }

  function cartPageUrl() {
    return shopifyRoot() + 'cart';
  }

  function updateCartBadge(count) {
    var n = parseInt(count, 10);
    if (isNaN(n) || n < 0) n = 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    document.querySelectorAll('.site-header__cart').forEach(function (link) {
      if (n > 0) link.setAttribute('aria-label', 'Cart (' + n + ')');
      else link.setAttribute('aria-label', 'Cart');
    });
  }

  function refreshCartBadge() {
    return fetch(cartJsUrl(), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('cart.js failed');
      return res.json();
    }).then(function (cart) {
      updateCartBadge(cart && cart.item_count);
      return cart;
    }).catch(function () { return null; });
  }

  function setProductAtcBusy(form, busy) {
    if (!form) return;
    var submitBtn = form.querySelector('[type="submit"][name="add"], [type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = !!busy;
      if (busy) submitBtn.setAttribute('aria-busy', 'true');
      else submitBtn.removeAttribute('aria-busy');
    }
    document.querySelectorAll('[data-sticky-atc-submit]').forEach(function (btn) {
      btn.disabled = !!busy;
      if (busy) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    });
  }

  function showAddedConfirm(form) {
    var host = (form && form.querySelector('.product__atc-desktop')) ||
      document.querySelector('.product__atc-desktop') ||
      form;
    if (host) {
      var el = host.querySelector('[data-atc-confirm]');
      if (!el) {
        el = document.createElement('p');
        el.className = 'product__atc-confirm';
        el.setAttribute('data-atc-confirm', '');
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        host.appendChild(el);
      }
      el.innerHTML = 'Added · <a href="' + cartPageUrl() + '">view cart</a>';
      el.hidden = false;
      window.clearTimeout(showAddedConfirm._t);
      showAddedConfirm._t = window.setTimeout(function () {
        el.hidden = true;
      }, 4000);
    }

    /* The desktop confirmation is hidden on mobile, so echo it on the sticky ATC. */
    var stickyButton = document.querySelector('.sticky-atc [data-sticky-atc-submit]');
    if (stickyButton) {
      var originalLabel = stickyButton.getAttribute('data-atc-original-label');
      if (originalLabel === null) {
        originalLabel = stickyButton.textContent.trim();
        stickyButton.setAttribute('data-atc-original-label', originalLabel);
      }
      stickyButton.textContent = 'Added · view cart';
      window.clearTimeout(showAddedConfirm._stickyT);
      showAddedConfirm._stickyT = window.setTimeout(function () {
        stickyButton.textContent = originalLabel;
      }, 4000);
    }
  }

  function reenableCartCheckout() {
    /* Browser disables the clicked submit during POST; bfcache restores that disabled state. */
    document.querySelectorAll('[data-cart-form] button[type="submit"], .cart__checkout, .cart__update').forEach(function (btn) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-disabled');
    });
  }

  function reenableProductAtc() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      setProductAtcBusy(form, false);
    });
  }

  /* PDP ATC: add selected variant (+ deposit selling_plan) as a cart line, stay on PDP.
     Does not clear existing lines — Shopify /cart/add appends. Deposit-only lock. */
  function initProductAddToCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    ensureDepositSellingPlanInput(form);
    /* If Downpay later strips selling_plan (pay-in-full), put deposit back. */
    try {
      var mo = new MutationObserver(function () {
        ensureDepositSellingPlanInput(form);
      });
      mo.observe(form, { childList: true, subtree: true });
    } catch (err) {}
    form.addEventListener('submit', function (e) {
      /* Allow normal submit if JS fetch fails; prefer AJAX stay-on-PDP */
      if (form.getAttribute('data-ajax-atc') === 'false') return;
      e.preventDefault();
      var planId = ensureDepositSellingPlanInput(form);
      setProductAtcBusy(form, true);
      var fd = new FormData(form);
      /* Ensure quantity at least 1 */
      if (!fd.get('quantity')) fd.set('quantity', '1');
      /* Force deposit selling plan on /cart/add.js — never pay-in-full */
      if (planId) fd.set('selling_plan', planId);
      else fd.delete('selling_plan');
      fetch(cartAddJsUrl(), {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd,
        credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      }).then(function () {
        return refreshCartBadge();
      }).then(function () {
        showAddedConfirm(form);
        setProductAtcBusy(form, false);
      }).catch(function () {
        setProductAtcBusy(form, false);
        /* Fallback: classic form post (return_to = product URL) */
        form.submit();
      });
    });
  }

  /* bfcache / Back: badge goes stale; Checkout/ATC can stay disabled after form nav. */
  function initPageshowRepair() {
    window.addEventListener('pageshow', function () {
      refreshCartBadge();
      reenableProductAtc();
      reenableCartCheckout();
    });
  }

  function initMobileNav() {
    document.querySelectorAll('[data-site-header]').forEach(function (header) {
      var toggle = header.querySelector('[data-mobile-nav-toggle]');
      if (!toggle) return;
      var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!drawer) return;

      var closeButtons = drawer.querySelectorAll('[data-mobile-nav-close], [data-mobile-nav-link]');
      var closeButton = drawer.querySelector('.mobile-nav__close');
      var panel = drawer.querySelector('.mobile-nav__panel');
      var lastFocused = null;

      function openNav() {
        lastFocused = document.activeElement;
        drawer.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        document.documentElement.classList.add('is-mobile-nav-open');
        if (closeButton) closeButton.focus();
      }

      function closeNav() {
        if (drawer.hidden) return;
        drawer.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.documentElement.classList.remove('is-mobile-nav-open');
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }

      toggle.addEventListener('click', function () {
        if (drawer.hidden) openNav();
        else closeNav();
      });
      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeNav);
      });
      document.addEventListener('keydown', function (event) {
        if (drawer.hidden) return;
        if (event.key === 'Escape') {
          closeNav();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusable = panel ? panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])') : [];
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 768) closeNav();
      });
    });
  }

  function initHashWaitlist() {
    if (location.hash === '#waitlist') {
      window.setTimeout(function () {
        var target = document.getElementById('waitlist');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var email = target.querySelector('input[type="email"], input[name="contact[email]"]');
        if (email) email.focus();
      }, 200);
    }
  }


  document.addEventListener('shopify:section:unload', function (event) {
    var api = window.BrojanicaProductViewer;
    if (api && event.target) api.destroyViewer(event.target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initPriceCards();
    initAccordion();
    initGallery();
    initCordPicker();
    initKaratPickers();
    initStickyATC();
    initProductAddToCart();
    initPageshowRepair();
    initMobileNav();
    initHashWaitlist();
    refreshCartBadge();
    reenableCartCheckout();
    var mount = document.querySelector('[data-product-viewer]');
    if (mount && mount.dataset.cordColor) filterGalleryByCord(mount.dataset.cordColor);
    else filterGalleryByCord('black');
  });
})();
